import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import ProductCard from "@/components/ProductCard";
import { useAuth } from "@/context/AuthContext";

export default function Catalog() {
  const { category } = useParams();
  const [sp] = useSearchParams();
  const q = sp.get("q") || "";
  const { API } = useAuth();
  const [products, setProducts] = useState([]);
  const [sort, setSort] = useState("featured");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (category) params.category = category;
    if (q) params.q = q;
    axios.get(`${API}/products`, { params })
      .then(r => setProducts(r.data))
      .finally(() => setLoading(false));
  }, [category, q, API]);

  const sorted = [...products].sort((a, b) => {
    if (sort === "price-asc") return a.price - b.price;
    if (sort === "price-desc") return b.price - a.price;
    if (sort === "name") return a.name.localeCompare(b.name);
    return (b.featured ? 1 : 0) - (a.featured ? 1 : 0);
  });

  const title = q
    ? `Search · "${q}"`
    : category === "kurti" ? "Kurtis" : category === "co-ord" ? "Co-ord Sets" : "All Collections";

  return (
    <div data-testid="catalog-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="border-b border-[#E5DFD3] pb-10 mb-10 flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div>
          <div className="label-eyebrow">{q ? "Results" : "Shop"}</div>
          <h1 className="font-display text-5xl md:text-6xl mt-3" data-testid="catalog-title">{title}</h1>
          <p className="mt-3 text-sm text-[#5C5454]">{products.length} pieces{q ? " match your search" : " · ethically made"}</p>
        </div>
        <div>
          <label className="label-eyebrow mr-3">Sort</label>
          <select
            data-testid="catalog-sort"
            value={sort}
            onChange={e => setSort(e.target.value)}
            className="bg-transparent border-b border-[#2D2626] py-2 px-2 text-sm focus:outline-none"
          >
            <option value="featured">Featured</option>
            <option value="price-asc">Price · Low to High</option>
            <option value="price-desc">Price · High to Low</option>
            <option value="name">Name</option>
          </select>
        </div>
      </div>

      {loading ? (
        <div className="py-20 text-center text-sm text-[#5C5454]" data-testid="catalog-loading">Loading collection…</div>
      ) : sorted.length === 0 ? (
        <div className="py-20 text-center" data-testid="catalog-empty">
          <p className="font-display text-3xl">Nothing here yet</p>
          <p className="text-sm text-[#5C5454] mt-3">{q ? `We couldn't find pieces matching "${q}". Try a different word.` : "No pieces in this collection yet."}</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8" data-testid="catalog-grid">
          {sorted.map(p => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
